
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SupportAssistantConversation } from "@/interfaces/SupportAssistant.interfaces";

@Component({ name: "ConversationSidebar" })
export default class ConversationSidebar extends Vue {
  @Prop({ required: true, type: Array })
  readonly conversations!: SupportAssistantConversation[];

  @Prop({ default: null })
  readonly activeConversationId!: string | null;

  @Prop({ default: false, type: Boolean })
  readonly loading!: boolean;

  formatDate(value: string): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return "";
    }

    const today = new Date();
    if (date.toDateString() === today.toDateString()) {
      return date.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit"
      });
    }

    return date.toLocaleDateString([], { month: "short", day: "numeric" });
  }

  formatPreview(value: string): string {
    return value
      .replace(/^#{1,6}\s+/gm, "")
      .replace(/\*\*([^*]+)\*\*/g, "$1")
      .replace(/__([^_]+)__/g, "$1")
      .replace(/`([^`]+)`/g, "$1");
  }
}
